import React, { useEffect } from 'react';
import LocationSender from './components/LocationSender';
import Header from './components/Header';
import Footer from './components/Footer';
import { LanguageProvider, useTranslation } from './context/LanguageContext';
import './App.css';

const AppContent = () => {
  const { t, lang } = useTranslation();

  useEffect(() => {
    // Dynamic SEO Management
    document.title = t('meta_title');
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', t('meta_desc'));
    }
    // Update language attribute on HTML tag
    document.documentElement.lang = lang === 'ceb' ? 'ceb' : 'en';
  }, [lang, t]);

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      <Header />
      <main className="flex-grow pb-12" id="main-content">
        <LocationSender />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;